import React from 'react';
import { PackageOpen } from 'lucide-react';
import { Button } from './UI';

export default function EmptyState({ title = 'No data found', message = 'Get started by adding the first record.', action, actionLabel = 'Add New', icon: Icon = PackageOpen }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <Icon size={28} className="text-gray-400" />
      </div>
      <h3 className="text-base font-semibold text-gray-700 mb-1">{title}</h3>
      <p className="text-sm text-gray-400 mb-6 max-w-xs">{message}</p>
      {action && (
        <Button onClick={action}>{actionLabel}</Button>
      )}
    </div>
  );
}
